<template>
  <v-autocomplete
    v-model="object"
    :label="itemAction.name"
    :item-text="itemText"
    :items="objects"
    :item-value=" (itemAction.itemValue)? itemAction.itemValue : 'id'"
    :search-input.sync="findObject"
    no-data-text="Sin Resultados"
    :disabled="itemAction.readonly"
    clearable
    outlined
    dense>
      <template v-slot:selection="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold subtitle-2" >{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold font-weight-black">{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>
  </v-autocomplete>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SearchDinamicField',
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    object: null,
    objects: [],
    findObject: null
  }),
  created () {
    this.setModel(this.setterModel)
  },
  methods: {
    itemText (item) {
      if (item && (this.itemAction.nameid === 'cve_empleado' || this.itemAction.nameid === 'empleado_id' || this.itemAction.nameid === 'solicitante_id')) {
        return `${item.NombreCompleto}`
      } else if (item && (this.itemAction.nameid === 'departamento_id')) {
        return `${item.nombre}`
      } else if (item && this.itemAction.nameid === 'ejercicio_id') {
        return `${item.descripcion}`
      } else if (item && this.itemAction.nameid === 'insumo_id') {
        return `${item.descripcion.descripcion}`
      } else if (item && this.itemAction.nameid === 'inventario_id') {
        return `${item.folio} - ${item.caracteristicas.descripcion}`
      } else {
        return `${item.nombre}`
      }
    },
    getDinamicData (name) {
      const token = this.$cookies.get('token')
      axios.get(`${this.itemAction.url}/${name}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.objects = []
        this.objects.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },
    postDinamicData (name) {
      const token = this.$cookies.get('token')
      axios.post(`${this.itemAction.url}`, { name }, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.objects = []
        this.objects.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },
    clearData (e) {
      this.onSuccess({ id: this.itemAction.nameid, data: null })
    },
    setModel (val) {
      if (val) {
        switch (this.itemAction.nameid) {
          case 'empleado_id':
            if (val.empleado) {
              this.object = val.empleado.id
              this.objects.push(val.empleado)
            }
            break
          case 'solicitante_id':
            if (val.solicitante) {
              this.object = val.solicitante.id
              this.objects.push(val.solicitante)
            }
            break
          case 'departamento_id':
            if (val.departamento) {
              this.object = val.departamento.id
              this.objects.push(val.departamento)
            }
            break
          case 'lugar_nacimiento_id':
            if (val.lugar_nacimiento) {
              this.object = val.lugar_nacimiento.id
              this.objects.push(val.lugar_nacimiento)
            }
            break
          case 'localidad_id':
            if (val.localidad) {
              this.object = val.localidad[this.itemAction.itemValue]
              this.objects.push(val.localidad)
            }
            break
          case 'inventario_id':
            if (val.inventario) {
              this.object = val.inventario[this.itemAction.itemValue]
              this.objects.push(val.inventario)
            }
            break
        }
      }
    }
  },
  watch: {
    findObject (val) {
      if (val === null || val === '') return

      if (this.itemAction.method) {
        this.postDinamicData(val.replace(' ', '_'))
      } else {
        this.getDinamicData(val.replace(' ', '_'))
      }
    },
    object (val) {
      let model = {}
      this.objects.map(item => {
        if (item[(this.itemAction.itemValue) ? this.itemAction.itemValue : 'id'] === val) model = item
      })
      this.onSuccess({ id: this.itemAction.nameid, data: val, action: this.itemAction.action, field: this.itemAction, objetModel: model })
      // this.onSuccess({ id: this.itemAction.nameid, data: val })
    },
    setterModel (val) {
      if (val) {
        this.setModel(val)
      }
    }
  }
}
</script>

<style>

</style>
